import React,{ Component } from 'react';
import { Route } from 'react-router-dom';
import { Redirect } from 'react-router';
import { getLocale } from 'core/i18n';


export class AuthRoute extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isAuthed: false  // 是否通過權限檢核
    }
  }

  checkAuth(){
    let isAuthed = false
    isAuthed = sessionStorage.getItem('user') ? true : false;
    this.setState({isAuthed: isAuthed })
  }

  UNSAFE_componentWillMount(){
    this.checkAuth()
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.path !== this.props.path) {
      this.checkAuth()
    }
  }
  
  render () {
    const { component: Component, ...rest } = this.props;
    const { isAuthed } = this.state;

    return (
      <Route {...rest} render={props => (
        isAuthed
          ? <Component {...props} />
          : <Redirect to={{ pathname: `/${getLocale()}/Login`, state: { from: props.location } }} />
      )} />
    );
  }

}

export default AuthRoute;